var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-content mt-3" },
    [
      _c("text-area-row", {
        attrs: {
          title: "SummaryReport.TargetGroup.Name",
          id: "detail-entry-name_" + _vm.index,
          required: true,
          maxLength: 50,
          rows: 1,
          disabled: _vm.isDisabled
        },
        model: {
          value: _vm.detailEntry.name,
          callback: function($$v) {
            _vm.$set(_vm.detailEntry, "name", $$v)
          },
          expression: "detailEntry.name"
        }
      }),
      _vm._v(" "),
      _c("radio-button-row", {
        staticClass: "mt-0",
        attrs: {
          title: "SummaryReport.TargetGroup.IsOrganisation",
          required: true,
          componentIndex: _vm.index
        },
        model: {
          value: _vm.detailEntry.isOrganisation,
          callback: function($$v) {
            _vm.$set(_vm.detailEntry, "isOrganisation", $$v)
          },
          expression: "detailEntry.isOrganisation"
        }
      }),
      _vm._v(" "),
      _c("radio-button-option-row", {
        attrs: {
          title: "SummaryReport.TargetGroup.CollectionMethod",
          required: true,
          componentIndex: _vm.index,
          options: _vm.optionsArray("UpdatedCollectionMethodOptions", true)
        },
        model: {
          value: _vm.detailEntry.updatedCollectionMethod,
          callback: function($$v) {
            _vm.$set(_vm.detailEntry, "updatedCollectionMethod", $$v)
          },
          expression: "detailEntry.updatedCollectionMethod"
        }
      }),
      _vm._v(" "),
      _vm.showRealizedNumber
        ? _c("numeric-input-row", {
            attrs: {
              title: "SummaryReport.TargetGroup.RealizedNumber",
              id: "detail-entry-number_" + _vm.index,
              required: true
            },
            model: {
              value: _vm.detailEntry.realizedNumber,
              callback: function($$v) {
                _vm.$set(_vm.detailEntry, "realizedNumber", $$v)
              },
              expression: "detailEntry.realizedNumber"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAgeGenderDistribution
        ? _c("age-gender-distribution-table", {
            attrs: {
              title: "SummaryReport.TargetGroup.DistributionHeading",
              distribution: _vm.detailEntry.ageGenderDistribution,
              componentIndex: _vm.index
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }